// src/terminal/auth.js
//
// BBS Terminal password verification ONLY.
// Uses simple hashing — NO bcrypt, NO jwt, NO server packages.
//
// HOW TO GENERATE HASHES:
// 1. Open browser console (F12)
// 2. Paste the hashPassword function
// 3. Run: hashPassword('yourpassword')
// 4. Copy the number into KNOWN_HASHES

function hashPassword(str) {
  const s = str.toLowerCase().trim();
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < s.length; i++) {
    const ch = s.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

// REPLACE these with your actual hash outputs from the browser console
const KNOWN_HASHES = {
  skyla:     7429750012033779,  
  root:      6142022740967182, 
  chrysalis: 5160221766983781,  
  rajiv:     164876621760590,
  opuweb:    3257222986786547, 
};

export function verifyPassword(key, attempt) {
  if (!KNOWN_HASHES[key]) return false;
  return hashPassword(attempt) === KNOWN_HASHES[key];
}

export { hashPassword };